import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, keyframes, style, animate } from '@angular/animations';

@Component({
  selector: 'app-tech-profile-pic',
  templateUrl: './tech-profile-pic.component.html',
  animations: [
    trigger('isVisibleChanged', [
        transition('void => *', [
            animate(600, keyframes([
                style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
            ]))
        ])
    ])
],
})
export class TechProfilePicComponent implements OnInit {

  constructor() { }
  isVisible: boolean = false;
  @Input() Attachment: string = '';
  @Output() done = new EventEmitter();
  ngOnInit() {
  }
  close(){
    this.done.emit(true);
  }
}
